module.exports = __webpack_public_path__ + "static/media/rain.334d2937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/home/possibleBackgrounds/rain.jpg
// module id = 2015
// module chunks = 1